import { observer } from "mobx-react-lite";
import React, { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import { DropdownItem } from "reactstrap";
import { translationHookOptions } from "../../app/localization/localization";
import { ILanguage } from "../../app/models/company";
import GenericModal from "../common/GenericModal";
import LanguageSettingsComponent from "../widgets/LanguageSettingsComponent";
import { RootStore, RootStoreContext } from "../../app/stores/rootStore";

interface IParams {
  UISupportedLanguages: ILanguage[];
}

const MainNavBarLanguageSetting: React.FC<IParams> = ({
  UISupportedLanguages,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const rootStore = useContext(RootStoreContext);
  const {  allLanguages } = rootStore.commonStore;
  const [t] = useTranslation(["translation"], translationHookOptions);

  return (
    <>
      {UISupportedLanguages.length > 1 ? (
        <>
          <DropdownItem onClick={() => setIsModalOpen(true)}>
            {t("navbar_dropdown_change_language")}
          </DropdownItem>
          <DropdownItem divider />
          <GenericModal
            isOpen={isModalOpen}
            toggle={() => setIsModalOpen(false)}
            title={t("navbar_dropdown_change_language")}
            content={
              <LanguageSettingsComponent
                // UISupportedLanguages={UISupportedLanguages}
                UISupportedLanguages={allLanguages}
              />
            }
            actions={[]}
            size="md"
            modalBodyClassname="languages-settings-modal"
          />
        </>
      ) : (
        <></>
      )}
    </>
  );
};

export default observer(MainNavBarLanguageSetting);
